// Só para exibição: conta, histórico e pagamento seguem com o nome de registro (`name`).
export function nomeExibicao(p?: { name?: string | null; socialName?: string | null } | null): string {
  return p?.socialName?.trim() || p?.name || '';
}
